import React from 'react'

export function useAlert(initialState: boolean): [boolean, () => void, () => void] {
    const [show, setShow] = React.useState(initialState)

    const open = () => setShow(true)
    const close = () => setShow(false)

    return [show, open, close]
}
export default useAlert
